import { Box, Grid, Typography } from '@mui/material';
import React ,{ useState, useEffect, createContext} from 'react';
import AddEdit from './AddEdit';
import GstTable from './GstTable';
import { GstServices } from './services';
import { PermissionGuard } from '../../../../components/PermissionGuard';
import { useParams } from 'react-router-dom';

const GstDataContext = createContext();
const Gst = () => {
    const {id} = useParams();
    const gstInitialData = {
        sac: '',
        rcm: false,
        igst: 0,
        cgst: 0,
        sgst: 0,
        igstNon: 0,
        cgstNon: 0,
        sgstNon: 0,
        tcs: 1,
        taxSlab:0,
        title:'',
    }
    const [gstData, setGstData] = useState(gstInitialData);

    const [paginationModel,setPaginationModel] = useState({
        page: 0,
        pageSize: 5,
        filters: {
            // searchKey: "",
            sortBy:'updatedAt',
            sortType:'desc',
            filterOptions: []
        }
    })
    const [gstList, setGstList] = useState([]);
    const [totalRowCount,setTotalRowCount] = useState(0);
    const [loadingList,setLoadingList] = useState(false)

    const fetchGstList = async() => {
        setLoadingList(true);
        try{
            const response = await GstServices.fetchGstList(paginationModel);
            console.log('gst list fetching response :',response);

            if(response.success == '1'){
                setGstList(response.data.list)
                setTotalRowCount(response.data.totalItems)
            }else if (response.success == '0'){
                console.log("error :",response?.message)
            }
        }catch (error){
            console.log("error:",error)
        }finally{
            setLoadingList(false)
        }
        
    }

    const [selectedGstData, setSelectedGstData] = useState(null);
  return (
    <GstDataContext.Provider value={{gstInitialData,gstData,setGstData,fetchGstList,gstList,paginationModel,setPaginationModel,totalRowCount,loadingList,selectedGstData, setSelectedGstData}}>
        <Grid container spacing={1}>            
            <Grid item xs={12} lg={5}>
                <AddEdit/>
            </Grid>
            <PermissionGuard feature="gst" permission="canView">
                <Grid item xs={12} lg={7}>
                    <GstTable/>
                </Grid>
            </PermissionGuard>
        </Grid>
    </GstDataContext.Provider>
  );
}

export default Gst;
export {GstDataContext};
